import Hero from "./components/Hero";
import Categories from "./components/Categories";
import HotAndFeatured from "./components/HotAndFeatured";
import ArticlesAndAbout from "./components/ArticlesAndAbout";
import Reviews from "./components/Reviews";
import FaqAndCta from "./components/FaqAndCta";

export default function Home() {
  return (
    <>
      <Hero />
      <Categories />
      <HotAndFeatured />
      <ArticlesAndAbout />
      <Reviews />
      <FaqAndCta />
    </>
  );
}